import React from "react";
import { useTranslation } from "react-i18next";
const footerImageUrl = "https://s3-us-west-1.amazonaws.com/e-templates/default/powered_by_alertmedia.png";

const Footer = (props) => {
  const { t } = useTranslation();
  return (
    <div id="footer" data-cy="footer">
      <a href="http://www.alertmedia.com">
        <img
          id="header-image"
          alt={t("footer.powered_by_alt")}
          src={props.style.footer_image_url || footerImageUrl} // passing style down
          title={t("footer.powered_by_title")}
        />
      </a>
    </div>
  );
};

export default Footer;
